import * as swcHelpers from '@swc/helpers';
import { Types } from '@grandvisionhq/graphql';
import { getLocalizedStrings } from '@grandvisionhq/utils';
import '../../../utils/cart-count-var.js';
import '../../../utils/cart-id-var.js';
import { getAttribute } from '../../../utils/get-line-item-attribute.js';
import { getLineItemAvailability } from '../../../utils/get-line-item-availability.js';
import { getLineItemImageUrl } from '../../../utils/get-line-item-image-url.js';
import { getLocalizedAttribute } from '../../../utils/get-line-item-localized-attribute.js';
import '@grandvisionhq/commercetools';
import '../../../utils/get-unrecoverable-validation-errors.js';
import '../../../models/line-item/prescription-glasses.js';
import { getEyeSide } from '../../../utils/get-eye-side.js';
import '../../../utils/get-failure-error-codes.js';
import { toBaseLineItem } from './base-line-item.js';
import { getContactLensA11yLabel } from './utils/get-product-a11y-label.js';
import { getProductTitle } from './utils/get-product-title.js';

const toEyeSideLabelKey = (eyeSide)=>{
    switch(eyeSide === null || eyeSide === void 0 ? void 0 : eyeSide.toUpperCase()){
        case Types.EyeSide.LEFT:
            return 'products.contactLenses.leftEye';
        case Types.EyeSide.RIGHT:
            return 'products.contactLenses.rightEye';
        case Types.EyeSide.BOTH:
        default:
            return undefined;
    }
};
const toEyeSide = (eyeSide)=>{
    switch(eyeSide){
        case 'left':
            return 'left';
        case 'right':
            return 'right';
        case 'both':
            return 'both';
        default:
            return undefined;
    }
};
const toEyePrescription = (prescriptionData)=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    return {
        addition: (ref = prescriptionData.addition) === null || ref === void 0 ? void 0 : ref.toString(),
        axis: (ref1 = prescriptionData.axis) === null || ref1 === void 0 ? void 0 : ref1.toString(),
        baseCurve: (ref2 = prescriptionData.baseCurve) === null || ref2 === void 0 ? void 0 : ref2.toString(),
        cylinder: (ref3 = prescriptionData.cylinder) === null || ref3 === void 0 ? void 0 : ref3.toString(),
        power: (ref4 = prescriptionData.power) === null || ref4 === void 0 ? void 0 : ref4.toString(),
        diameter: (ref5 = prescriptionData.diameter) === null || ref5 === void 0 ? void 0 : ref5.toString(),
        dominance: prescriptionData.dominance
    };
};
const toContactLensesCartLineItem = (cartLineItem, intl, settings, apiUrl)=>{
    var ref;
    const variant = cartLineItem.legacyProduct.masterData.current.variant;
    const eyeSide = toEyeSide(getEyeSide(cartLineItem.typeDetails));
    const eyeSideLabelKey = eyeSide !== 'both' ? toEyeSideLabelKey(eyeSide) : undefined;
    const eyeSideLabel = eyeSideLabelKey ? `${intl.getLabel(eyeSideLabelKey)},` : undefined;
    const packageQuantity = getAttribute(variant, 'packageQuantity');
    const replacementFrequency = getLocalizedAttribute(variant, 'replacementFrequency', intl.locale);
    const unit = intl.getLabel('products.unit.contactLenses');
    const subtitle = [
        eyeSideLabel,
        packageQuantity,
        replacementFrequency,
        unit
    ].filter(Boolean).join(' ');
    const prescription = toEyePrescription(cartLineItem.typeDetails.prescriptionData);
    const title = getProductTitle(cartLineItem.legacyProduct, intl);
    const colorValues = getLocalizedStrings(cartLineItem.typeDetails.colors, intl.locale);
    const colorLabel = `${intl.getLabel('products.lensColor')}: ${colorValues.join(', ')}`;
    return swcHelpers.objectSpread({}, toBaseLineItem(cartLineItem, settings, intl), {
        productType: 'contact-lenses',
        title,
        eyeSide,
        prescription,
        type: 'CONTACT_LENSES',
        subtitle,
        imageUrl: getLineItemImageUrl(variant),
        altText: prescription ? getContactLensA11yLabel(prescription, intl, title, eyeSideLabel) : title
    }, variant.availability ? {
        availability: getLineItemAvailability(variant.availability)
    } : {}, {
        quoteConfig: (cartLineItem === null || cartLineItem === void 0 ? void 0 : (ref = cartLineItem.quote) === null || ref === void 0 ? void 0 : ref.quoteToken) ? {
            quoteUrl: `${apiUrl}/quotes/${cartLineItem.quote.quoteToken}`,
            hasQuoteLink: Boolean(settings.shouldShowQuoteLink)
        } : undefined,
        additionalInfo: colorValues.length ? [
            colorLabel
        ] : undefined
    });
};

export { toContactLensesCartLineItem, toEyePrescription };
//# sourceMappingURL=contact-lenses-line-item.js.map
